<template>
    <div v-if="show" class="invalid-feedback d-block">
        {{ $errors.first(input) }}
    </div>
</template>

<script>

export default {
    props: ['input'],
    data: () => ({

    }),
    methods: {},
    computed: {
        show() {
            return this.$errors.has(this.input);
        }
    },
    watch: {},
    mounted() {}
}
</script>

<style scoped>

</style>
